// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".star-rating{unicode-bidi:bidi-override;color:#c5c5c5;font-size:18px;width:90px;margin:0 auto;position:relative;padding:0}td.compare .star-rating{margin-left:0}.star-rating-active{color:#2D878D}.star-rating .no-rating{font-size:10px}\n", ""]);
// Exports
module.exports = exports;
